/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Metadata_Table_PropertyInputs */



/**
* | output |
* | --- |
* | "Metadata Property" |
*
* @param {Event_Group_Metadata_Table_PropertyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_metadata_table_property = /** @type {((inputs?: Event_Group_Metadata_Table_PropertyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Metadata_Table_PropertyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Propriété de métadonnées")
	if (locale === "de") return /** @type {LocalizedString} */ ("Metadaten-Eigenschaft")
	if (locale === "it") return /** @type {LocalizedString} */ ("Proprietà dei metadati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Свойство метаданных")
	if (locale === "es") return /** @type {LocalizedString} */ ("Propiedad de metadatos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("元数据属性")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メタデータプロパティ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मेटाडेटा प्रॉपर्टी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Propriedade de metadados")
	return /** @type {LocalizedString} */ ("Metadata Property")
});